import { useEffect } from 'react';
import { AppState, Platform } from 'react-native';
import { useAuthStore } from '@/store/auth';
import { getStorage } from '@/store/storage';
import { startNativeAuthRecovery } from '@/lib/nativeAuthRecovery';

export default function useNativeAuthRecovery() {
  useEffect(() => {
    if (Platform.OS !== 'ios' && Platform.OS !== 'android') return undefined;
    return startNativeAuthRecovery({ store: useAuthStore, storage: getStorage(), appState: AppState });
  }, []);
}
